<template>
    <div class="basic_wrap">
        <div class="top_nav">
            <van-icon name="arrow-left" class="back_icon" @click="$router.back()" />
            <div class="nav_title">{{$t('moneybag.withdrawRecord')}}</div>
        </div>
        
        <div class="main_content">
            <div class="balance_card m-card">
                <p class="balance_label">{{$t('moneybag.accountBalance')}}</p>
                <p class="balance_val">{{$t('utils.moneyMark')}}{{funds}}</p>
                <div class="action_btns">
                    <div class="btn recharge_btn" @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</div>
                    <div class="btn withdraw_btn" @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</div>
                </div>
            </div>

            <van-empty :description="$t('item.noData')" v-if="listShow" />
            
            <div class="detail_box" v-if="!listShow">
                <div class="list-item m-card" v-for="item in data" :key="item.id || item.time">
                    <div class="de_wrap">
                        <p class="tit">{{item[lang]}}</p>
                        <p class="time">{{item.time}}</p>
                    </div>
                    <div class="price" :class="item.type =='1'?'':'del'" v-html="item.type =='1'?$t('utils.moneyMark')+item.money : '-'+$t('utils.moneyMark')+item.money"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import { DropdownMenu, DropdownItem, Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "withdrawRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 2
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = r.data.money;
                this.userName = r.data.username;
            })
        },
        methods: {
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        background-color: #F1F4F6;
        min-height: 100vh;
        padding-bottom: 20px;
    }

    .top_nav {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 46px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        
        .back_icon {
            position: absolute;
            left: 15px;
            font-size: 20px;
            color: #333;
            cursor: pointer;
        }
        
        .nav_title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
    }

    .main_content {
        padding: 61px 15px 15px; // 46px + 15px
    }

    .m-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.02);
    }

    .balance_card {
        padding: 25px 20px;
        text-align: center;
        margin-bottom: 15px;
        
        .balance_label {
            font-size: 13px;
            color: #666;
            margin-bottom: 8px;
        }
        
        .balance_val {
            font-size: 32px;
            color: #4F46E5;
            font-weight: bold;
            margin-bottom: 20px;
        }
        
        .action_btns {
            display: flex;
            justify-content: space-between;
            gap: 15px;
            
            .btn {
                flex: 1;
                padding: 12px 0;
                font-size: 14px;
                border-radius: 8px;
                font-weight: bold;
                cursor: pointer;
            }
            
            .recharge_btn {
                background: #4F46E5;
                color: #fff;
                box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3);
            }
            
            .withdraw_btn {
                background: #F1F4F6;
                color: #4F46E5;
            }
        }
    }

    .detail_box {
        .list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px;
            margin-bottom: 10px;

            .de_wrap {
                flex: 1;
                margin-right: 10px;

                .tit {
                    font-size: 14px;
                    color: #333;
                    font-weight: bold;
                    margin-bottom: 6px;
                    word-break: break-all;
                }

                .time {
                    font-size: 12px;
                    color: #999;
                }
            }

            .price {
                flex-shrink: 0;
                font-size: 16px;
                font-weight: bold;
                text-align: right;
                color: #4F46E5; // text-blue
                white-space: nowrap;
                
                &.del {
                    color: #10B981; // text-green for negative/withdrawals
                }
            }
        }
    }
</style>